// extracted by mini-css-extract-plugin
module.exports = {"addPaymentsfooter":"style_addPaymentsfooter__3c0Ow","editPaymentsfooter":"style_editPaymentsfooter__DLveB"};